import React from 'react';
import { PropTypes } from 'prop-types';
import { Box, Grid, Typography } from '@mui/material';

const InfoBox = props => {
    const {
        title,
        titleAction,
        children,
        leftColumnContent,
        disableLeftColumn,
        disableContentWrapper,
        sx,
        ...rest
    } = props;

    return (
        <Box
            sx={theme => ({
                padding: '20px',
                borderRadius: '5px',
                background: theme.palette.grey[200],
                '&:not(:last-child)': {
                    marginBottom: theme.spacing(5),
                },
                ...sx,
            })}
            {...rest}
        >
            {!!title && (
                <Box display="flex" alignItems="center" gap={1}>
                    <Typography color="primary" variant="subtitle1" gutterBottom={!titleAction}>
                        {title}
                    </Typography>
                    {titleAction}
                </Box>
            )}
            <Grid container spacing={0}>
                {!disableLeftColumn && (
                    <Grid
                        item
                        sx={theme => ({
                            flex: '0 1 120px',
                            textAlign: 'center',
                            padding: theme.spacing(0, 1),
                        })}
                    >
                        {leftColumnContent}
                    </Grid>
                )}
                {disableContentWrapper ? (
                    children
                ) : (
                    <Grid
                        item
                        sx={theme => ({
                            flex: '1 1',
                            '&:not(:last-child)': {
                                marginRight: theme.spacing(0, 2),
                            },
                        })}
                    >
                        {children}
                    </Grid>
                )}
            </Grid>
        </Box>
    );
};

InfoBox.propTypes = {
    title: PropTypes.string,
    titleAction: PropTypes.node,
    children: PropTypes.node,
    leftColumnContent: PropTypes.node,
    disableLeftColumn: PropTypes.bool,
    disableContentWrapper: PropTypes.bool,
    sx: PropTypes.object,
};

export default InfoBox;
